module.exports = new __parcel__URL__("RightLobby.abdef7c3.hdr").toString();